export var RuleDataTypeEnum;
(function (RuleDataTypeEnum) {
    RuleDataTypeEnum["VEHICLE"] = "vehicle";
})(RuleDataTypeEnum || (RuleDataTypeEnum = {}));
